import { FC } from 'react';
import { useHasAccessServices } from 'components/hooks/services/useBoardServices';
import { RequestAccess } from './RequestAccess';
import { Service } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { TrackedPage } from 'services/Logger';

interface IRequestAccessIfMissingProps {
    service: Service;
    useIcon?: boolean;
    buttonClass?: string;
    trackedPage?: TrackedPage;
}

export const RequestAccessIfMissing: FC<IRequestAccessIfMissingProps> = ({ service, useIcon, buttonClass, trackedPage }) => {
    const { hasAccessTo } = useHasAccessServices();
    const { serviceKey, url } = service;

    if (!serviceKey || hasAccessTo(serviceKey)) {
        return null;
    }

    return (
        <RequestAccess
            serviceKey={serviceKey}
            url={url || ''}
            useIcon={useIcon}
            buttonClass={buttonClass}
            trackedPage={trackedPage}
        />
    );
};
